import React, { Component, useState } from "react";
import "./Resources.css";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import Webinars from "../../Components/Webinars/Webinars";
import RelateOrganizations from "../RelateOrganizations/RelateOrganizations";
import PromoMaterials from "../PromoMaterials/PromoMaterials";
import Testimonials from "../Testimonials/Testimonials";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

export const Resources = (props) => {
  const [category, setCategory] = useState(props.category);
  // console.log(category);
  return (
    <div className={`resources-wrapper ${category}`}>
      <div className="ac-wrapper-btns">
        <Tabs>
          <TabList>
            <Tab>
              <div className="ac-innertab">
                <div className="ac-icon">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-icon="users"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 512"
                    className="svg-users"
                  >
                    <path
                      fill="currentColor"
                      d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                      className=""
                    ></path>
                  </svg>
                </div>
                <p>
                  {category == "mice"
                    ? "Member Organizations"
                    : "Related Organizations"}
                </p>
              </div>
              <hr />
            </Tab>
            <div className="ac-border"></div>
            <Tab>
              <div className="ac-innertab">
                <div className="ac-icon">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-icon="download"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className="svg-download"
                  >
                    <path
                      fill="currentColor"
                      d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                      className=""
                    ></path>
                  </svg>
                </div>
                <p>Promotional Material</p>
              </div>
              <hr />
            </Tab>
            <div className="ac-border"></div>

            <Tab>
              <div className="ac-innertab">
                <div className="ac-icon">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-icon="youtube"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    className="youtube-svg"
                  >
                    <path
                      fill="currentColor"
                      d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                      className=""
                    ></path>
                  </svg>
                </div>
                <p>Webinars</p>
              </div>
              <hr />
            </Tab>
            {/* <div className="ac-border"></div>
            <Tab>
              <div className="ac-innertab">
                <div className="ac-icon">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-icon="ac-star"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    className="svg-star"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                      className=""
                    ></path>
                  </svg>
                </div>
                <p>Testimonials</p>
              </div>
              <hr />
            </Tab> */}
          </TabList>
          <div className="ac-tabs-content">
            <TabPanel>
              <RelateOrganizations category={category} />
            </TabPanel>
            <TabPanel>
              <PromoMaterials category={category} />
            </TabPanel>

            <TabPanel>
              <Webinars category={category} />
            </TabPanel>
            {/* <TabPanel>
              <Testimonials />
            </TabPanel> */}
          </div>
        </Tabs>
      </div>
      {/*<div className="ac-wrapper-indicator">
        <div className="ac-innerwrapper-indicator"></div>
       </div>*/}
    </div>
  );
};

export default Resources;



// WEBPACK FOOTER //
// ./src/Components/Resources/Resources.js